import React, { FC } from 'react';

import { Box } from '@mui/material';
import { styled } from '@mui/material';

import CategoryLink from '~/pages/DiscoverPage/components/CategoryLink';
import { buildCategoryRoute } from '~/routes';
import { MIDDLE_MARGIN_PX, SMALL_MARGIN_PX, SUBMIDDLE_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';
import { VideoCategory } from '~/types';

interface SubcategoriesBlockProps {
  categorySlug?: string | null;
  childCategories?: VideoCategory[] | null;
  className?: string;
}

const SubcategoriesBlock: FC<SubcategoriesBlockProps> = ({
  categorySlug,
  childCategories,
  className,
}) => {
  return childCategories ? (
    <CategoriesWrapper className={className}>
      {childCategories.map((item) => (
        <CategoryLink
          data-testid="subcategoryItem"
          key={item?.slug}
          to={buildCategoryRoute(categorySlug, item?.slug)}
        >
          {item?.title}
        </CategoryLink>
      ))}
    </CategoriesWrapper>
  ) : null;
};

export default SubcategoriesBlock;

const CategoriesWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: ${SUBMIDDLE_MARGIN_PX};
  margin-top: ${SMALL_MARGIN_PX};

  & a {
    margin-right: ${TINY_MARGIN_PX};
    margin-bottom: ${TINY_MARGIN_PX};

    &:last-child {
      margin-right: 0;
    }
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    justify-content: flex-start;
    padding-bottom: 0;
    margin-top: ${MIDDLE_MARGIN_PX};
  }
`;
